import { InstallationWorkload } from "@/model/data/workload/InstallationWorkload";
import { GetWorkloadReqData } from "@/model/communication/workload/GetWorkloadReqData";

export class InstallationsWorkloadState {
    reqData: GetWorkloadReqData = new GetWorkloadReqData(null);

    installationsList: InstallationWorkload[] = [];
    totalInstallationsCount: number = 0;
    currencies: string[] = [];
    isInstallationsListFetching: boolean = false;

}

export default new InstallationsWorkloadState();